
/**
 * Module `exports`
 */

module.exports = function (superagent) {
  var Request = superagent.Request;
  Request.prototype.csrf = csrf;
  return superagent;
};

/**
 * Adds the CSRF token to the request headers
 *
 * @param {String} token
 */

function csrf (token) {
  if (!token) token = window._csrf;
  this.set('X-CSRF-Token', token);
  return this;
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/superagent-csrf/lib/index.js
// module id = 2296
// module chunks = 6